import { createFileRoute } from '@tanstack/react-router';

// The entire dashboard subtree is client-rendered only. Auth0 (localStorage),
// MUI/Emotion/styled-components and every dashboard feature never run on the
// server, so the build-time prerender pass touches none of this code.
export const Route = createFileRoute('/_dashboard')({
  ssr: false
});
